module.exports = __webpack_public_path__ + "static/Screen_inside_mob_03_on_landing-14396d14bbcc78e03621f50cf6768b79.png";